var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fillRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10,0 C15.5228475,0 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,0 10,0 Z M10.9914286,13.9890867 L8.99297424,13.9890867 L8.99297424,15.987541 L10.9914286,15.987541 L10.9914286,13.9890867 Z M9.99217799,3.99686183 C7.78388759,3.99686183 5.99531616,5.78548009 5.99531616,7.99372365 L7.99377049,7.99372365 C7.99377049,6.89456674 8.89306792,5.99526932 9.99222482,5.99526932 C11.0913817,5.99526932 11.9906323,6.89461358 11.9906323,7.99377049 C11.9906323,9.99222482 8.99297424,9.74238876 8.99297424,12.9898829 L10.9914286,12.9898829 C10.9914286,10.7416393 13.9890867,10.4918501 13.9890867,7.99377049 C13.9890867,5.78548009 12.2004684,3.99686183 9.99217799,3.99686183 Z",
    id: "Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.12844ab52ab1446e6ec3c64cc975cde6.svg";
export { ForwardRef as ReactComponent };